export default __webpack_public_path__ + "static/media/ci_special_offers.6de808ab.png";